@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        @if (!field?.settings?.format || field?.settings?.format === EnumerationFormat.DropDownList) {
          <div
            class="select is-secondary is-medium">
            <select (change)="dropdownSelected($event)" [(ngModel)]="dropdownValue">
              <option [value]=""></option>
              @for (enumValue of enumerationValues; track enumValue.value) {
                <option
                  [value]="enumValue.value">
                  {{ enumValue.name }}
                </option>
              }
            </select>
          </div>
        }
        @if (field?.settings?.format === EnumerationFormat.CheckBox) {
          <div
            class="checkbox-list">
            @for (enumValue of enumerationValues; track enumValue.value) {
              <div
                class="mb-2">
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  class="checkbox">
                  <topo-checkbox
                    [checked]="value?.includes(enumValue.value)"
                  (checkChanged)="checkChange(value?.includes(enumValue.value), enumValue.value)"></topo-checkbox>
                  {{ enumValue.name }}
                </div>
              </div>
            }
          </div>
        }
        @if (field?.settings?.format === EnumerationFormat.Radio) {
          <div
            class="radio-list">
            @for (enumValue of enumerationValues; track enumValue.value) {
              <div>
                <label class="radio">
                  <input
                    type="radio"
                    [value]="enumValue.value"
                    [name]="field.systemName"
                    [checked]="value?.includes(enumValue.value)"
                    (change)="checkChange($event)" />
                  {{ enumValue.name }}
                </label>
              </div>
            }
          </div>
        }
        @if (field?.settings?.format === EnumerationFormat.MuiltiSelect) {
          <div
            class="checkbox-list"
            >
            @for (enumValue of enumerationValues; track enumValue.value) {
              <div
                class="mb-2">
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  class="checkbox">
                  <topo-checkbox
                    [checked]="value?.includes(enumValue.value)"
                  (checkChanged)="checkChange(value?.includes(enumValue.value), enumValue.value)"></topo-checkbox>
                  {{ enumValue.name }}
                </div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="is-readonly">
        {{ selectedValue }}
      </div>
    }
  </div>
}
